/**
 * storybookPages — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const storybookPagesPack: ToilePack = {
    slug: 'storybook-pages',
    category: 'kidsbook',
    name: 'Storybook pages',
    tagline: tagline('pages', 'scenes', 'styles'),
    chips: chips('scenes', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'puddle', label: 'The puddle', subject: 'Pip the bear cub jumping into a big puddle'},
        {key: 'bakery', label: 'The bakery', subject: 'Pip on tiptoe at a bakery counter'},
        {key: 'bedtime', label: 'Bedtime', subject: 'Pip tucked into bed under a patchwork quilt'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'soft watercolor picture-book illustration', palette: 'gentle washes, pencil linework', framing: 'full-bleed page'},
        {key: 'papercut', label: 'Papercut', style: 'layered paper-cut illustration', palette: 'textured card stock', framing: 'full-bleed page'},
        {key: 'gouache', label: 'Gouache', style: 'bold gouache picture-book illustration', palette: 'limited cheerful palette', framing: 'full-bleed page'},
    ],
    directions: ['a rabbit instead', 'at night by lamplight', 'with a small friend along'],
}
